import { useEffect } from 'react';
import { ClaimContext, OnChangeClaimContext } from '../../types';

/**
 * Hook to automatically calculate the net value based on order items
 * Taking into account the tax if applicable
 */
export function useCalculateNetValueBasedOnOrderItems(
  isOrderItemsRequired: boolean,
  onChange: OnChangeClaimContext,
  orderItemContext: Pick<ClaimContext, 'orderItems' | 'isTaxIncluded' | 'taxRate'>
) {
  const { orderItems, isTaxIncluded, taxRate } = orderItemContext;

  useEffect(() => {
    if (isOrderItemsRequired) {
      const netValue = orderItems.reduce((acc, item) => acc + (Number(item.quantity) * Number(item.unitPrice) || 0), 0);

      if (isTaxIncluded) {
        const taxRateAsAFraction = Number(taxRate) / 100;

        onChange({
          netValue: netValue / (1 + taxRateAsAFraction),
        });
      } else {
        onChange({
          netValue,
        });
      }
    }
  }, [orderItems, isTaxIncluded, taxRate, isOrderItemsRequired, onChange]);
}
